import { Skeleton } from '@chakra-ui/react';
import { HStack } from 'components/ui';

export const DateSelectionSkeleton = () => (
  <HStack maxW={'100%'} overflow={'auto'}>
    <HStack flex={1} justifyContent={'space-between'} pt={6}>
      {Array.from({ length: 7 }).map((_, i) => (
        <Skeleton
          borderRadius={'lg'}
          height={{ base: '72px', sm: '72px' }}
          key={i}
          width={{ base: '48px', sm: '72px' }}
          marginRight={{ base: '12px', sm: '8px', md: undefined }}
        />
      ))}
    </HStack>
  </HStack>
);
